import { Component, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Alerta } from '../../../_models/alerta';
import { AlertaService } from '../../../_services/alerta.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Location } from '@angular/common';
import { AlertaPerfilRiesgoService } from '../../../_services/alerta-perfil-riesgo.service';
import { AlertaEstructuraFisicaService } from '../../../_services/alerta-estructura-fisica.service';
import { AlertaTipoVinculacionService } from '../../../_services/alerta-tipo-vinculacion.service';
import { AlertaPerfilRiesgo } from '../../../_models/alerta-perfil-riesgo';
import { AlertaEstructuraFisica } from '../../../_models/alerta-estructura-fisica';
import { AlertaTipoVinculacion } from '../../../_models/alerta-tipo-vinculacion';
import { PerfilRiesgoService } from '../../../_services/perfil-riesgo.service';
import { EstructuraFisicaService } from '../../../_services/estructura-fisica.service';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { EstadoService } from '../../../_services/estado.service';
import { NivelesService } from '../../../_services/niveles.service';
import { AlertaDetalleService } from '../../../_services/alerta-detalle.service';
import { AlertaAprobacionService } from '../../../_services/alerta-aprobacion.service';
import { AlertaDescarteService } from '../../../_services/alerta-descarte.service';
import { AlertaDetalle } from '../../../_models/alerta-detalle';
import { AlertaAprobacion } from '../../../_models/alerta-aprobacion';
import { AlertaDescarte } from '../../../_models/alerta-descarte';
import { AlertaExcepcion } from '../../../_models/alerta-excepcion';
import { AlertaExcepcionService } from '../../../_services/alerta-excepcion.service';

@Component( {
  selector: 'app-alerta-editar',
  templateUrl: 'alerta-detalle.component.html'
} )

export class AlertaDetalleComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  submitted = false;
  alerta: Alerta;
  regPerfiles: AlertaPerfilRiesgo[] = [];
  regEstructurasFisicas: AlertaEstructuraFisica[] = [];
  regVinculaciones: AlertaTipoVinculacion[] = [];
  perfiles: string;
  oficinas: string;
  vinculaciones: string;
  detalle: AlertaDetalle;
  descarte: AlertaDescarte;
  lisPerfiles: SelectItem[] = [];
  lisEstados: SelectItem[] = [];
  lisCausales: SelectItem[] = [];
  formulario: FormGroup;
  excepcion: AlertaExcepcion;


  constructor( private alerServicio: AlertaService,
               private alePerfilesRiesgosServicio: AlertaPerfilRiesgoService,
               private aleEstructurasFisicasServicio: AlertaEstructuraFisicaService,
               private aleTiposVinculacionesServicio: AlertaTipoVinculacionService,
               private aleDetalleServicio: AlertaDetalleService,
               private aleAprobacionServicio: AlertaAprobacionService,
               private aleDescarteServicio: AlertaDescarteService,
               private perRiesgosServicio: PerfilRiesgoService,
               private estFisicasServicio: EstructuraFisicaService,
               private estadosServicio: EstadoService,
               private nivelesServicio: NivelesService,
               private lisServicio: ListaService,
               private navServicio: NavService,
               private conServicio: ConfirmationService,
               private location: Location,
               private router: Router,
               private formBuilder: FormBuilder,
               private route: ActivatedRoute,
               private autServicio: AutenticacionService,
               private alertaExcepcionService: AlertaExcepcionService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.alerServicio.obtenerPorId( params[ 'id' ] ).subscribe( alerta => {
          this.alerta = alerta;
          forkJoin( this.alePerfilesRiesgosServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.aleEstructurasFisicasServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.aleTiposVinculacionesServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.aleDetalleServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.aleDescarteServicio.obtenerPorIdAlerta( this.alerta.idAlerta ),
            this.alertaExcepcionService.obtenerPorIdAlerta( this.alerta.idAlerta ) )
            .subscribe( ( [perfiles, estFisicas, tipVinculacion, detalle, descarte, excepcion] ) => {
              this.regPerfiles = perfiles.filter( p => p.indicadorHabilitado );
              this.regEstructurasFisicas = estFisicas.filter( ef => ef.indicadorHabilitado );
              this.regVinculaciones = tipVinculacion.filter( v => v.indicadorHabilitado );
              this.detalle = detalle ? detalle[ 0 ] : null;
              this.descarte = descarte ? descarte : null;
              this.excepcion = (excepcion && excepcion.length > 0) ? excepcion[ 0 ] : null;
              this.perfiles = this.regPerfiles.map( a => a.perfilesRiesgosNombre ).join( ', ' );
              this.oficinas = this.regEstructurasFisicas.map( a => a.estructuraFisicaNombre ).join( ', ' );
              this.vinculaciones = this.regVinculaciones.map( a => a.tiposVinculacionesNombre ).join( ', ' );
              this.carServicios();
            } );
        } );
      } else {
        this.carServicios();
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  carServicios() {
    this.carInformacionInicial = false;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }
}
